module.exports = __webpack_public_path__ + "img/sheet_change.94f337bb.svg";